import { render, staticRenderFns } from "./AdminListings.vue?vue&type=template&id=b2396db6"
import script from "./AdminListings.vue?vue&type=script&lang=js"
export * from "./AdminListings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2396db6')) {
      api.createRecord('b2396db6', component.options)
    } else {
      api.reload('b2396db6', component.options)
    }
    module.hot.accept("./AdminListings.vue?vue&type=template&id=b2396db6", function () {
      api.rerender('b2396db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminListings.vue"
export default component.exports